import { Image, message, Skeleton, Tooltip } from "antd";
import { StarFilled } from "@ant-design/icons";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  contactCompanyFav,
  contactCompanyGetDetails,
} from "services/redux/contact/companypeople/action";
import { cqBaseUrl } from "utils/config";
import { contactLabelGroupListing } from "services/remanentCalls";

const CompanyTemplateDetails = () => {
  const [contactLabelGroup, setContactLabelGroup] = useState([]);
  const companyAvatar = "assets/svg/company-avatar1.svg";
  const { contactCompanyGetDetailsResponse } = useSelector(
    (state) => state.contactCompanyPerson
  );
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchContactLabelGroupListing = async () => {
      try {
        const resp = await contactLabelGroupListing();
        if (resp?.status === 200) {
          setContactLabelGroup(resp.data);
        }
      } catch (error) {
        message.error("Failed to fetch contact label groups");
      }
    };
    fetchContactLabelGroupListing();
  }, []);

  const handleFavoriteToggle = () => {
    if (!contactCompanyGetDetailsResponse?.id) return;
    dispatch(
      contactCompanyFav(
        { contactCompanyId: contactCompanyGetDetailsResponse.id },
        contactCompanyGetDetailsResponse
      )
    );
  };

  const renderProfileImage = () => {
    if (isEmpty(contactCompanyGetDetailsResponse?.uploadedFileDtos)) {
      return <Image src={companyAvatar} preview={false} />;
    }
    const profileImage = contactCompanyGetDetailsResponse.uploadedFileDtos.find(
      (file) => file.fileLableTypeName === "Profile"
    );
    return profileImage ? (
      <Image
        src={`${cqBaseUrl}/${profileImage.viewFileURL}${token}`}
        preview={false}
      />
    ) : (
      <Image src={companyAvatar} preview={false} />
    );
  };

  const DetailRow = ({ label, value }) => (
    <div className="contactsDetails__info" style={{ display: "flex" }}>
      <div className="contactDetails__label" style={{ flex: 2 }}>
        <span className="contactsDetails--title bold w-100">{label}</span>
      </div>
      <div className="contactDetails__labeldata" style={{ flex: 9 }}>
        <span className="contactsDetails--subtitle bold">{value || "N/A"}</span>
      </div>
    </div>
  );

  if (!contactCompanyGetDetailsResponse) {
    return (
      <Skeleton
        avatar={{ size: 96, shape: "square" }}
        paragraph={{ rows: 10 }}
      />
    );
  }

  return (
    <div className="contactsDetails">
      <div className="contactsDetails__main">
        <div className="contactDetail header" style={{ paddingRight: "350px" }}>
          <div className="contact__details__image">{renderProfileImage()}</div>
          <div className="right-header">
            <div style={{ display: "flex" }}>
              <span
                onClick={handleFavoriteToggle}
                style={{ marginLeft: -20, width: 20, cursor: "pointer" }}
              >
                <StarFilled
                  style={{
                    color: contactCompanyGetDetailsResponse?.isFavorite
                      ? "#FBA525"
                      : "grey",
                  }}
                />
              </span>
              {contactCompanyGetDetailsResponse?.companyName && (
                <Tooltip
                  title={contactCompanyGetDetailsResponse.companyName}
                  placement="topLeft"
                >
                  <span className="contactsDetails--subtitle bold">
                    {contactCompanyGetDetailsResponse.companyName || "N/A"}
                  </span>
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyTemplateDetails;
